import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { UserProfile } from '../../../../@posturinn/client-react';
import { addEmail } from '../../../../actions/userActions';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button/button';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../base/forms/input';
import { Column, Columns } from '../../../base/grid';
import { H2 } from '../../../base/typography';
import { RawLoader } from '../../../loading/loading';
import * as StyledOnboarding from '../onboarding.styles';
import { stepProfileInitialValues, stepProfileSchema } from './stepProfile.schema';

interface Props {
	Proceed: any;
	NewUserProfile: UserProfile;
	SetNewUserProfile: any;
}

const StepProfile: FC<Props> = ({ Proceed, NewUserProfile, SetNewUserProfile }) => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { userProfile, addEmailUserLoading } = userProfileReducer;

	if (!userProfile) return <RawLoader />;

	stepProfileInitialValues.phone =
		(userProfile.phoneNumber && userProfile.phoneNumber.startsWith('+354')
			? userProfile.phoneNumber.substring(4)
			: userProfile.phoneNumber) || '';
	stepProfileInitialValues.email = userProfile.email || '';

	const sessionStoragePhone = window.sessionStorage.getItem('onboardingPhone');
	if (sessionStoragePhone) stepProfileInitialValues.phone = sessionStoragePhone;
	const sessionStorageEmail = window.sessionStorage.getItem('onboardingEmail');
	if (sessionStorageEmail) stepProfileInitialValues.email = sessionStorageEmail;

	const nextStep = () => {
		const phone = window.sessionStorage.getItem('onboardingPhone') || '';
		const email = window.sessionStorage.getItem('onboardingEmail');

		NewUserProfile.email = email;
		NewUserProfile.phoneNumber = phone.startsWith('+354') ? phone : phone.length === 7 ? '+354' + phone : phone;
		SetNewUserProfile(NewUserProfile);
		Proceed();
	};

	const submitStepProfile = (values, formikHelpers) => {
		window.sessionStorage.setItem('onboardingPhone', values.phone);
		window.sessionStorage.setItem('onboardingEmail', values.email);

		if (!checkVerifiedEmail(values.email)) {
			//adduser email
			dispatch(addEmail(userProfileReducer.userProfile.userId, values.email, null));
			formikHelpers.setSubmitting(false);
		}

		//dispatch(setActiveModal(VERIFY_EMAIL_SECURE_MODAL));
		if (checkVerifiedEmail(values.email)) {
			nextStep();
		}
	};

	const checkVerifiedEmail = email => {
		if (email === userProfile.email && userProfile.emailVerified) {
			return true;
		}

		return false;
	};

	return (
		<StyledOnboarding.LeftColumn>
			<Formik
				initialValues={stepProfileInitialValues}
				enableReinitialize
				validationSchema={stepProfileSchema}
				onSubmit={submitStepProfile}>
				{({ isSubmitting, values, errors }) => (
					<Form>
						<H2>{userProfile.name}</H2>
						<strong>{t('ssn') as string}:</strong>
						{userProfile.identificationNumber}
						<StyledOnboarding.InfoText>{t('onboarding.profile.infoText')}</StyledOnboarding.InfoText>
						<Columns>
							<Column>
								<FormikFieldWrapper
									label={t('phone')}
									name="phone"
									languageComponent="myShipments"
									smallLabel>
									<StyledFormikField type="text" id="phone" name="phone" placeholder={t('phone')} />
								</FormikFieldWrapper>
							</Column>
							<Column>
								<FormikFieldWrapper
									label={t('email')}
									name="email"
									languageComponent="myShipments"
									smallLabel>
									<StyledFormikField
										type="text"
										id="email"
										name="email"
										onKeyUp={e => {
											if (e && e.target && e.target.value && !errors.email) {
												// comment
											}
										}}
										placeholder={t('email')}
									/>
								</FormikFieldWrapper>
							</Column>
						</Columns>
						{checkVerifiedEmail(values.email) && (
							<StyledOnboarding.InfoText checkbox>
								{t('onboarding.profile.emailVerified')}
							</StyledOnboarding.InfoText>
						)}
						{checkVerifiedEmail(values.email) ? (
							<Button primary type="submit" isLoading={isSubmitting}>
								Næsta skref
							</Button>
						) : (
							<Button primary type="submit" isLoading={addEmailUserLoading}>
								{t('VERIFY_EMAIL.header')}
							</Button>
						)}
					</Form>
				)}
			</Formik>
		</StyledOnboarding.LeftColumn>
	);
};
export default StepProfile;
